import './interfaces-automations-v1-trigger-provider.public.js';
import { createServicePluginModule } from '@wix/sdk-runtime/service-plugin-modules';
import { BuildServicePluginDefinition } from '@wix/sdk-types';
import { provideHandlers as publicProvideHandlers } from './interfaces-automations-v1-trigger-provider.public.js';

export { publicProvideHandlers };

export const provideHandlers: BuildServicePluginDefinition<
  typeof publicProvideHandlers
> &
  typeof publicProvideHandlers = /*#__PURE__*/ createServicePluginModule(
  publicProvideHandlers
);
